import React from 'react'

const About = () => {
  return (
    <section className='section about-section'>
      <h1 className='section-title'> about us</h1>
      <p>lora impsum text</p>
    </section>
  )
}

export default About
